import { render, staticRenderFns } from "./score-list.vue?vue&type=template&id=0b39638a&"
import script from "./score-list.vue?vue&type=script&lang=js&"
export * from "./score-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports